import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UserApiService } from '../../services/user-api.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteAddressConfirm } from '../delete-address-confirm/component';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector: 'edit-user-addresses',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class EditUserAddresses implements OnInit {
  @Input() role: string;
  @Input() userId: string;

  form!: FormGroup;
  public loading = true;
  public addresses;

  constructor(
    private dialog: MatDialog,
    public userService: UserApiService,
    public router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadAddresses();
  }

  async loadAddresses() {
    this.addresses = (
      await this.userService.getAddresses(this.role, this.userId)
    ).addresses;
    this.loading = false;
  }

  deleteAccountConfirm(address) {
    this.dialog
      .open(DeleteAddressConfirm, {
        disableClose: true,
        data: { userId: this.userId, address: address },
      })
      .afterClosed()
      .subscribe(() => {
        this.loading = true;
        this.snackBar.open('Address deleted');
        this.loadAddresses();
      });
  }
}
